<template>
  <div class="locker-code-container text-start">
    <div class="d-flex align-items-center justify-content-between py-1">
      <HtmlText tag="h2" :text="$t('confirmation.number')" class="h3 mb-1"></HtmlText>
      <span class="badge">{{ locker.locker_number }}</span>
    </div>

    <template v-if="locker.zone">
      <div class="d-flex align-items-center justify-content-between py-1">
        <HtmlText tag="h2" :text="$t('confirmation.zone')" class="h3 mb-1"></HtmlText>
        <span class="badge">{{ locker.zone }}</span>
      </div>
    </template>

    <template
        v-if="locker.code"
    >
      <div class="d-flex align-items-center justify-content-between py-1">
        <HtmlText tag="h2" :text="$t('confirmation.pinCode')" class="h3 mb-1"></HtmlText>
        <span class="badge">{{ locker.code }}</span>
      </div>
    </template>

    <template
        v-if="locker.is_electronic_locker"
    >
      <div class="d-flex align-items-center justify-content-between py-1">
        <HtmlText tag="h2" :text="$t('confirmation.openButton')" class="h3 mb-1"></HtmlText>
        <button
            class="btn btn-success"
            @click="openLocker"
        >
          {{ $t('locker.openLocker') }}
        </button>
      </div>
    </template>

    <open-locker-dialog
        :locker="locker"
        :token="token"
        :event-bus="eventBus"
    />
  </div>
</template>

<script>
import HtmlText from '../components/HtmlText';
import OpenLockerDialog from '@/components/OpenLockerDialog.vue';
import Vue from 'vue';

export default {
  props: [
    'locker',
    'lockerSize',
    'token',
  ],

  components: {
    OpenLockerDialog,
    HtmlText,
  },

  data() {
    return {
      eventBus: new Vue(),
    };
  },

  methods: {
    /**
     * Open a locker.
     */
    openLocker() {
      this.eventBus.$emit('openLocker')
    },
  },
};
</script>
